// NewKBBoard-Header.js
import React from 'react';
import { Flex, Text, Button, Box } from '@chakra-ui/react';

const NewKBBoardHeader = ({
  filteredLeadsCount,
  totalLeadsCount,
  isLoadingAllPages,
  hasMore,
  onClearFilters,
  onLoadAllLeads,
  isLoading // Loading state specifically for the button
}) => {
  const showClearFilters = filteredLeadsCount !== totalLeadsCount;

  return (
    <Flex px={1} justifyContent="space-between" alignItems="center" mt={1} mb={1}>
      {totalLeadsCount > 0 ? (
        <Flex fontSize="xs">
          <Text color="gray.600">
            {filteredLeadsCount} of {totalLeadsCount}{isLoadingAllPages ? '+' : ''} leads{isLoadingAllPages ? ' (loading more...)' : ''}
          </Text>
          {showClearFilters && (
            <Text
              ml={2}
              color="blue.500"
              cursor="pointer"
              fontWeight="medium"
              onClick={onClearFilters}
            >
              Clear filters
            </Text>
          )}
        </Flex>
      ) : (
        <Box></Box> // Placeholder to maintain layout
      )}

      {/* Load All button */}
      {hasMore && !isLoadingAllPages && (
        <Button
          size="xs"
          colorScheme="blue"
          variant="ghost"
          onClick={onLoadAllLeads}
          isLoading={isLoading} // Use the specific loading state passed
          loadingText="Loading..."
        >
          Load All Leads
        </Button>
      )}
    </Flex>
  );
};

export default NewKBBoardHeader;